import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { X } from "lucide-react";
import tentsSunset from "@/assets/glamping/tents-sunset.jpg";

export function Glamping2026Modal() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setOpen(true), 300);
    return () => clearTimeout(t);
  }, []);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent
        className="max-w-lg w-[95vw] p-0 border-0 bg-transparent overflow-hidden"
        hideDefaultClose
      >
        <DialogTitle className="sr-only">
          Glamping Update for 2026
        </DialogTitle>

        <div className="relative rounded-lg overflow-hidden bg-cream shadow-2xl">
          {/* Sticky close */}
          <button
            onClick={() => setOpen(false)}
            className="absolute top-4 right-4 z-20 w-10 h-10 rounded-full bg-charcoal/90 hover:bg-charcoal flex items-center justify-center transition-colors shadow-lg border-2 border-white/30"
            aria-label="Close"
          >
            <X className="w-5 h-5 text-white" />
          </button>

          {/* Hero image */}
          <img
            src={tentsSunset}
            alt="Son's Guadalupe bell tents glowing at sunset along the river"
            className="w-full h-56 md:h-72 object-cover"
          />

          {/* Body */}
          <div className="p-6 md:p-8 text-center">
            <h2 className="font-lora text-2xl md:text-3xl font-bold text-teal mb-4">
              Glamping Update for 2026
            </h2>
            <p className="font-inter text-charcoal/90 text-base md:text-lg leading-relaxed mb-3">
              Son's Guadalupe <strong>will not be offering overnight glamping</strong> for the 2026 season. We will still be offering <strong>cabanas & tubing</strong>.
            </p>
            <p className="font-inter text-charcoal/80 text-sm md:text-base leading-relaxed mb-6">
              If you'd like to stay the night on the river, please visit one of our sister properties.
            </p>

            <a
              href="https://sonsgetaways.com"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block w-full md:w-auto py-3 px-8 bg-coral-orange hover:bg-coral-orange/90 text-white font-bold text-lg rounded-lg transition-all transform hover:scale-[1.02] shadow-lg"
            >
              Learn More
            </a>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
